import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";
import Index from "./pages/Index";
import Services from "./pages/Services";
import ApplicationSelect from "./pages/ApplicationSelect";
import ClientForm from "./pages/ClientForm";
import ServiceRequest from "./pages/ServiceRequest";
import Login from "./pages/Login";
import CRM from "./pages/CRM";
import Quotation from "./pages/Quotation";
import Invoices from "./pages/Invoices";
import ClientList from "./pages/ClientList";
import ClientManagement from "./pages/ClientManagement";
import LetterOfEngagement from "./pages/LetterOfEngagement";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <HashRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Index />} />
            <Route path="/services" element={<Services />} />
            <Route path="/apply" element={<ApplicationSelect />} />
            <Route path="/client-form" element={<ClientForm />} />
            <Route path="/service-request" element={<ServiceRequest />} />
            <Route path="/login" element={<Login />} />
            
            {/* Protected Admin Routes */}
            <Route path="/crm" element={
              <ProtectedRoute>
                <CRM />
              </ProtectedRoute>
            } />
            <Route path="/quotation" element={
              <ProtectedRoute>
                <Quotation />
              </ProtectedRoute>
            } />
            <Route path="/invoices" element={
              <ProtectedRoute>
                <Invoices />
              </ProtectedRoute>
            } />
            <Route path="/client-list" element={
              <ProtectedRoute>
                <ClientList />
              </ProtectedRoute>
            } />
            <Route path="/client-management" element={
              <ProtectedRoute>
                <ClientManagement />
              </ProtectedRoute>
            } />
            <Route path="/letter-of-engagement" element={
              <ProtectedRoute>
                <LetterOfEngagement />
              </ProtectedRoute>
            } />
            
            <Route path="*" element={<NotFound />} />
          </Routes>
        </HashRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;